import { router, MainRoutes, getHomeRoute } from './index'
import { PermissionItem } from '@/apis/modules/user'
import type { RouteRecordRaw } from 'vue-router'
import { filterTree } from '@/utils/index'

/**
 * 重置路由
 */
export function resetRouter() {
  router.getRoutes().forEach((route) => {
    const { name, meta } = route
    if (name && meta?.isNeedLogin !== false) {
      router.removeRoute(name)
    }
  })
}

/**
 * 获取有权限routes并注册
 * @param userPermissions
 */
export function registerRoutes(userPermissions: PermissionItem[]) {
  const routes = MainRoutes
  const addRoutes = filterTree<RouteRecordRaw>(routes, (item) => {
    const { permissions: permKeys } = item.meta || {}
    return !permKeys || hasPermission(permKeys, userPermissions)
  })
  addRoutes.forEach((route) => {
    router.addRoute(route)
  })

  // 新增 home 路由
  function getFirstRoutePath(routes: RouteRecordRaw[]) {
    if (!routes.length) return ''
    const children = routes[0]?.children
    return children?.length ? children[0].path : routes[0].path
  }
  const homePath = getFirstRoutePath(addRoutes) || '/403'
  router.addRoute(getHomeRoute(homePath))
}

/**
 * 是否有权限，关键方法
 * @param permKeys 权限项key[]
 * @param userPermissions 后端返回用户权限[]
 */
export function hasPermission(permKeys: string[], userPermissions: PermissionItem[]) {
  return permKeys.every((_key) => {
    const [type, key] = _key.split(':')
    const item = userPermissions.find((it) => it.keyPattern === key)
    return !!item?.hasPerm && (type === 'view' || !item.onlyQuery)
  })
}
